import { NgModule } from "@angular/core";
import { WholeNumberToDecimalPipe } from "./whole-number-to-decimal-number.pipe";
import { DatePipe, DecimalPipe } from "@angular/common";
import { CustomDatePipe, FindDuplicatePipe, FormatNumberPipe, PhoneMaskPipe, TimeFormatPipe } from ".";
import { SafeHtmlPipe } from "./safe-html.pipe";
import { CanDeactivateGuard } from "../services/authguards/can-deactivate-route.authguard";
import { SafeUrlPipe } from "./safe-url.pipe";

@NgModule({
  declarations: [
    PhoneMaskPipe, FindDuplicatePipe, WholeNumberToDecimalPipe,
    FormatNumberPipe, TimeFormatPipe, CustomDatePipe, SafeUrlPipe,
    SafeHtmlPipe,
  ],
  providers: [CanDeactivateGuard, DatePipe, DecimalPipe, FindDuplicatePipe,
    { provide: DatePipe, useClass: CustomDatePipe },
  ],
  exports: [
    PhoneMaskPipe, FindDuplicatePipe, WholeNumberToDecimalPipe,
    FormatNumberPipe, TimeFormatPipe, CustomDatePipe, SafeUrlPipe,
    SafeHtmlPipe,
  ],
})
export class AllPipesModule { }
